import { Checkbox } from '@lifeomic/chroma-react/components/Checkbox';
import { Filter } from '../../types';
import { useIntl } from 'react-intl';
import React, { Dispatch, FC, SetStateAction } from 'react';
import { FilterCheckboxProps } from './FilterCheckbox';

export type FilterCheckboxWithContextProps = FilterCheckboxProps & {
  isChecked: boolean;
  setIsChecked: Dispatch<SetStateAction<boolean>>;
};

export const FilterCheckboxWithContext: FC<FilterCheckboxWithContextProps> = ({
  injectedProps: { checkboxOption, searchKey },
  onFilterAdd,
  onFilterRemove,
  origin,
  selectedFilterOptions,
  isChecked,
  setIsChecked,
}) => {
  const { formatMessage } = useIntl();

  // Handle case where item is de-selected from BagOfChips
  // instead of manually un-checked
  React.useEffect(() => {
    const state = Boolean(
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      selectedFilterOptions.find(
        filterOption => filterOption.searchKey === searchKey,
      ),
    );

    if (state !== isChecked) {
      setIsChecked(state);
    }
  }, [isChecked, searchKey, selectedFilterOptions, setIsChecked]);

  const handleChange = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);

    const option: Filter = {
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      friendlyName: formatMessage(checkboxOption.intlLabel),
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      id: checkboxOption.id,
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      origin,
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      searchKey,
      searchValue: newValue,
    };

    if (newValue) {
      onFilterAdd?.(option);
    }

    if (!newValue) {
      onFilterRemove?.(option);
    }
  };

  return (
    <Checkbox
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      label={formatMessage(checkboxOption.intlLabel)}
      checked={isChecked}
      onChange={handleChange}
    />
  );
};
